module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "datatable"
    }
  }, [(_vm.hasSearchPower) ? _c('div', [(_vm.$route.name !== 'ItemBank') ? _c('form', {
    staticClass: "form-inline pull-right"
  }, [(_vm.filterCriteria.length > 0) ? _c('div', {
    staticClass: "form-group m-r-10"
  }, _vm._l((_vm.filterCriteria), function(criteria, index) {
    return _c('span', {
      key: index,
      staticClass: "label label-info m-r-5"
    }, [_vm._v(_vm._s(criteria))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Kata kunci"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field),
      expression: "field"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.field = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.headers), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doFilter()
      }
    }
  }, [_vm._v("Filter")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Hapus Filter")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.orderBy
    },
    on: {
      "change": _vm.updateOrderBy
    }
  }, [_c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("Baru ke Lama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("Lama ke Baru")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasFilterStatus) ? _c('div', {
    staticClass: "hasfilterstatus"
  }, [_c('div', {
    staticClass: "flex-disp"
  }, [_c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus(null)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === null ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        ALL\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === null ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('CHECKOUT')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CHECKOUT' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Checkout\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CHECKOUT' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('CONFIRMED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CONFIRMED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Confirmed\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CONFIRMED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('ACTIVATED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'ACTIVATED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Activated\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'ACTIVATED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('REJECTED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REJECTED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Rejected\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REJECTED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('EXPIRED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'EXPIRED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Expired\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'EXPIRED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('REFUND')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REFUND' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Refund\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REFUND' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('CANCELED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CANCELED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Canceled\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CANCELED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [(_vm.hasCheckbox) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": "All"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, "All") > -1 : (_vm.selectAll)
    },
    on: {
      "click": function($event) {
        return _vm.checkboxSelectAll()
      },
      "change": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "All",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("No.")]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(header))])
  }), _vm._v(" "), (_vm.hasAction || _vm.hasExport) ? _c('th', [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.hasPaymentStatus) ? _c('th', [_vm._v("Status")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentPageItems), function(values, key) {
    return _c('tr', {
      key: key,
      class: {
        'success': _vm.selectedRow == key
      },
      on: {
        "dblclick": function($event) {
          return _vm.selectRowAndFinish(key)
        },
        "click": function($event) {
          return _vm.selectRow(key)
        }
      }
    }, [(_vm.hasCheckbox) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCheckbox),
        expression: "selectedCheckbox"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": values.id,
        "checked": Array.isArray(_vm.selectedCheckbox) ? _vm._i(_vm.selectedCheckbox, values.id) > -1 : (_vm.selectedCheckbox)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCheckbox,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = values.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCheckbox = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCheckbox = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.startNumber + key + 1))]), _vm._v(" "), _vm._l((values.data), function(value, index) {
      return _c('td', {
        key: index,
        class: _vm.hasSoldoutWarning && values.data[2] < 50 ? 'sold-out' : '',
        staticStyle: {
          "word-break": "break-all"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(value)
        }
      }, [_vm._v(_vm._s(index))])])
    }), _vm._v(" "), (_vm.hasPaymentStatus) ? _c('td', _vm._l((values.status), function(values, index) {
      return _c('div', {
        key: index
      }, [_c('span', {
        staticClass: "label",
        class: {
          'label-warning': (values === 'CHECKOUT'),
          'label-primary': (values === 'CONFIRMED'),
          'label-danger': (values === 'EXPIRED' || values === 'REJECTED' || values === 'CANCELED'),
          'label-success': (values === 'ACTIVATED'),
          'label-default': (values === 'REFUND')
        },
        staticStyle: {
          "font-size": "0.9em"
        }
      }, [_vm._v("\n              " + _vm._s(values) + "\n            ")])])
    }), 0) : _vm._e(), _vm._v(" "), (values.actions) ? _c('td', _vm._l((values.actions), function(action) {
      return _c('button', {
        key: action.command,
        staticClass: "btn btn-xs btn-edit m-1",
        class: action.style,
        on: {
          "click": function($event) {
            _vm.$emit(action.command, _vm.selectRow(key))
          }
        }
      }, [_vm._v(_vm._s(action.text))])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.hasAction) ? _c('td', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row",
        "justify-content": "flex-start",
        "align-items": "baseline"
      }
    }, [(_vm.hasGrading) ? _c('button', {
      staticClass: "btn btn-info btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          _vm.$emit('gradingTryout', _vm.selectRow(key))
        }
      }
    }, [_vm._v("Grading")]) : _vm._e(), _vm._v(" "), (_vm.hasRanking) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          _vm.$emit('rankingTryout', _vm.selectRow(key))
        }
      }
    }, [_vm._v("Top 10")]) : _vm._e(), _vm._v(" "), (_vm.hasEdit) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          return _vm.editItem(key)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.hasEditA) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          return _vm.editItemContent(key)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.hasPreview) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-preview m-1",
      attrs: {
        "data-toggle": "modal",
        "data-target": ".bd-example-modal-sm"
      },
      on: {
        "click": function($event) {
          return _vm.previewVideo(values)
        }
      }
    }, [_vm._v("Preview")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'DRAFT') ? _c('button', {
      staticClass: "btn btn-success btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.publishing(values)
        }
      }
    }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'HIDDEN') ? _c('button', {
      staticClass: "btn btn-success btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.publishing(values)
        }
      }
    }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'PUBLISHED') ? _c('button', {
      staticClass: "btn btn-danger btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.unpublishing(values)
        }
      }
    }, [_vm._v("Unpublish")]) : _vm._e(), _vm._v(" "), (_vm.hasDelete) ? _c('button', {
      staticClass: "btn btn-danger btn-xs m-1",
      on: {
        "click": function($event) {
          return _vm.deleteItem(key)
        }
      }
    }, [_vm._v("Hapus")]) : _vm._e(), _vm._v(" "), (_vm.hasAddQuota) ? _c('button', {
      class: _vm.hasSoldoutWarning && values.data[2] < 50 ? 'btn btn-danger btn-xs m-1' : 'btn btn-success btn-xs m-1',
      on: {
        "click": function($event) {
          return _vm.$emit('addQuota', values)
        }
      }
    }, [_vm._v("Tambah Kuota")]) : _vm._e(), _vm._v(" "), (_vm.hasPreview) ? _c('div', {
      staticClass: "modal fade bd-example-modal-sm",
      attrs: {
        "tabindex": "-1",
        "role": "dialog",
        "aria-labelledby": "mySmallModalLabel",
        "aria-hidden": "true"
      }
    }, [_c('div', {
      staticClass: "modal-dialog modal-sm"
    }, [_c('div', {
      staticClass: "modal-content"
    }, [_c('youtube', {
      ref: "youtube",
      refInFor: true,
      attrs: {
        "video-id": _vm.videoId
      },
      on: {
        "playing": _vm.playing
      }
    })], 1)])]) : _vm._e()]) : _vm._e()], 2)
  }), 0)]), _vm._v(" "), (_vm.$route.name !== 'ItemBank' && _vm.$route.name !== 'FreeItemBank') ? _c('div', [(_vm.hasSearchPower) ? _c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(this.maxPage))])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0 && _vm.hasSearchPower) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("\n        Previous\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxPage
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.currentPage < _vm.maxPage) ? _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("\n        Next\n      ")]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fdc936e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/DataTable.vue
// module id = 1362
// module chunks = 0